import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  icon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
    cursor: 'pointer',
    color: theme.palette.select.light,
  },
}))
